import { useState, useCallback } from 'react';

const SESSION_KEY = 'admin_session_token';

export interface AdminSession {
  token: string | null;
  setToken: (token: string) => void;
  clearToken: () => void;
  isAuthenticated: boolean;
}

export function useAdminSession(): AdminSession {
  const [token, setTokenState] = useState<string | null>(() =>
    sessionStorage.getItem(SESSION_KEY)
  );

  const setToken = useCallback((t: string) => {
    sessionStorage.setItem(SESSION_KEY, t);
    setTokenState(t);
  }, []);

  const clearToken = useCallback(() => {
    sessionStorage.removeItem(SESSION_KEY);
    setTokenState(null);
  }, []);

  return {
    token,
    setToken,
    clearToken,
    isAuthenticated: token !== null,
  };
}
